import { lazyLoadComponentFactory } from "@Components/Modules/Helpers";

export default lazyLoadComponentFactory(
    () => import(/* webpackChunkName: "header-serach-results" */ "./header-search-results"),
);
